module.exports = __webpack_public_path__ + "static/media/benefit_1.e5048ce0.svg";